// Public Cognito config for the quoting pool. Pool ID + public client ID are NOT secrets.
// Filled from WoxomQuotingProductionAuthStack outputs (deployed 2026-07-03).
export const AUTH_CONFIG = {
  userPoolId: 'us-east-1_xSGPEYDz7',
  userPoolClientId: '428g7l0nehakd37r9tauedhj9c',
  region: 'us-east-1',
};

const STORE = 'wq_auth';

/** Decode a JWT payload without verifying the signature (client-side expiry check only). */
function decodePayload(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try { return JSON.parse(atobUrl(parts[1])); } catch { return null; }
}
function atobUrl(b64url) {
  const b64 = b64url.replace(/-/g, '+').replace(/_/g, '/');
  const bin = (typeof atob === 'function') ? atob(b64) : Buffer.from(b64, 'base64').toString('binary');
  return bin;
}

/** True only if the token has an exp at least 60s in the future. No signature check (that's the backend's job). */
export function isTokenValid(idToken, nowMs) {
  const p = decodePayload(idToken);
  if (!p || !p.exp) return false;
  const now = (typeof nowMs === 'number' ? nowMs : Date.now());
  return p.exp * 1000 - 60_000 > now;
}

export function getStoredIdToken() {
  try { return (JSON.parse(localStorage.getItem(STORE) || '{}')).idToken || null; } catch { return null; }
}
export function setSession(tokens) { localStorage.setItem(STORE, JSON.stringify(tokens || {})); }
export function clearSession() { localStorage.removeItem(STORE); }

export const AuthConfig = { AUTH_CONFIG, isTokenValid, getStoredIdToken, setSession, clearSession };
